export default {
      id: "add-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#add",
      toString: function () {
        return this.url;
      }
    }